import React from "react";
import { Box } from "@mui/material";
import StorageFactory from "../../Util/StorageFactory";
import { SESSION_USER_ID_KEY } from "../../Util/VMConstants";
import { isEmpty } from "../../Util/UtilHelper";
import LandingToolBar from "../../Main/Landing/LangingToolBar";
import FooterSection from "../Landing/FooterSection";
import TutorialsContent from "./TutorialsContent";

function VMDemo() {
  const sessionFactory = new StorageFactory("session");
  const userID = sessionFactory.get(SESSION_USER_ID_KEY);

  return (
    <Box sx={{ backgroundColor: "#ffffff", minHeight: "100vh" }}>
      {isEmpty(userID) && <LandingToolBar />}
      <TutorialsContent />
      {isEmpty(userID) && (
        <Box sx={{ mt: 4 }}>
          <FooterSection />
        </Box>
      )}
    </Box>
  );
}

export default VMDemo;
